import { Environment } from 'ngx-paf-common';

export const pafEnvironment : Environment = {
  debug:  true,
  apiBaseUrl:  'https://api-qas.paf.heiv.info/api/',
  portalType:  'INTRANET',
  oktaBaseUri:  'https://dev-53284405.okta.com/',
  production : false,
  authenticationType :  'azure',
  logo: 'Logo_Equans.png',
  logoUrl:  'https://www.equans.fr',
  logoNgStyle :  {'height':'55px','object-fit':'contains'}
};


export const  azureEnvironnent = {
  clientId:'80f68696-3bc4-49ed-a129-cabd50126258',
  authority: 'https://login.microsoftonline.com/02285139-4373-4712-8b87-391400e9fa31',
  apiBaseUrl :'https://api-qas.paf.heiv.info/api/',
  protectedResourceScopes: ['api://3d97a28a-e25a-45d3-97cc-088d6c71e6ac/access_as_user'],
  redirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/login/callback',
  postLogoutRedirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/loggedout',
}
